import { ActivityContactCell } from './ActivityContactCell'
import { CellRendererParams } from '../EntityTable/types'
import { DataClassName } from '@/Data/const'

export const ActivityPersonsCell = (params: CellRendererParams) => {
  return (
    <ActivityContactCell {...params} contactEntity={DataClassName.PERSON} />
  )
}

export const ActivityPersonsCellWithIcon = (params: CellRendererParams) => {
  return (
    <ActivityContactCell
      {...params}
      contactEntity={DataClassName.PERSON}
      showIcon
      icon="user-multiple"
    />
  )
}
